module.exports = __webpack_public_path__ + "img/email.cf78973c.svg";